import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4798effe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "new-modal-dialog modal-vue-size" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_no_login = _resolveComponent("no-login")!
  const _component_no_channels = _resolveComponent("no-channels")!
  const _component_add_subscribe = _resolveComponent("add-subscribe")!
  const _component_update_subscribe = _resolveComponent("update-subscribe")!
  const _component_success = _resolveComponent("success")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.hideModal && $options.hideModal(...args))),
        class: "new-modal fade in modal-vue"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
            class: "new-modal-content"
          }, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.close && $options.close(...args))),
              class: "new-modal-close"
            }),
            _createElementVNode("div", {
              class: _normalizeClass(["new-modal-body", this.load ? 'new-modal-loading' : ''])
            }, [
              (!this.load)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (!this.currentUser)
                      ? (_openBlock(), _createBlock(_component_no_login, { key: 0 }))
                      : (!this.subscribeChannels?.email?.length && !this.subscribeChannels?.telegram?.length)
                        ? (_openBlock(), _createBlock(_component_no_channels, { key: 1 }))
                        : (!this.openSuccessModal && !this.subscribe.id)
                          ? (_openBlock(), _createBlock(_component_add_subscribe, {
                              key: 2,
                              subscribe: this.subscribe,
                              subscribeKey: this.subscribeKey,
                              onClose: $options.hideModal
                            }, null, 8 /* PROPS */, ["subscribe", "subscribeKey", "onClose"]))
                          : (!this.openSuccessModal && this.subscribe.id)
                            ? (_openBlock(), _createBlock(_component_update_subscribe, {
                                key: 3,
                                subscribe: this.subscribe,
                                subscribeKey: this.subscribeKey,
                                onClose: $options.hideModal
                              }, null, 8 /* PROPS */, ["subscribe", "subscribeKey", "onClose"]))
                            : (_openBlock(), _createBlock(_component_success, {
                                key: 4,
                                "org-name": this.orgName ? this.orgName : this.subscribe.entityName,
                                onClose: $options.hideSuccessModal
                              }, null, 8 /* PROPS */, ["org-name", "onClose"]))
                  ]))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */)
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}